import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

import "./task-edited-standard.scss";

const TaskEditedStandard = ({ show, onHide, labels }) => {
  const [showModal, setShowModal] = useState(show ?? false);

  return (
    <Modal
      show={showModal}
      onHide={onHide ?? (() => setShowModal(false))}
      className="task-edited-standard"
    >
      <Modal.Body className="task-edited-popup">
        <div className="icon-confirm"></div>
        <h3 className="text-confirm">
          The {labels?.TaskSingular ?? 'task'} has been edited successfully.
        </h3>
        <div className="button-row">
          <NavLink to="/tasks">
            <Button className="btn-large">Go to {labels?.TaskPlural ?? 'Task'} List</Button>
          </NavLink>
          <Button
            onClick={onHide ?? (() => setShowModal(false))}
            className="btn-large btn-outlined "
          >
            Continue Editing
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default TaskEditedStandard;
